module.exports = "../images/icon-cabins.svg?v=7241b9b";